import { Routes } from '@angular/router';
import { userSlugGuard } from 'src/app/common/slug/user-slug.guard';

export const PROFILE_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./profile.component').then(c => c.ProfileComponent),
    canActivate: [userSlugGuard],
  },
  {
    path: ':slug',
    loadComponent: () => import('./profile.component').then(c => c.ProfileComponent),
    canActivate: [userSlugGuard],
  },
  {
    path: ':slug/rete',
    loadComponent: () =>
      import('./profile-networks-map/profile-networks-map.component').then(c => c.ProfileNetworksMapComponent),
  },
  {
    path: ':slug/network',
    loadComponent: () =>
      import('./profile-networks-map/profile-networks-map.component').then(c => c.ProfileNetworksMapComponent),
  },
  {
    path: ':slug/red',
    loadComponent: () =>
      import('./profile-networks-map/profile-networks-map.component').then(c => c.ProfileNetworksMapComponent),
  },
  {
    path: ':slug/reseau',
    loadComponent: () =>
      import('./profile-networks-map/profile-networks-map.component').then(c => c.ProfileNetworksMapComponent),
  },
  {
    path: ':slug/netzwerk',
    loadComponent: () =>
      import('./profile-networks-map/profile-networks-map.component').then(c => c.ProfileNetworksMapComponent),
  },
];
